import { Types } from "./BreadcrumbConstants";

export function setBreadCrumb(payload) {
    return (dispatch) => {
        dispatch({ type: Types.SET_BREADCRUMB, payload: payload });
    }
}

const exports = {
    Types,
}

export default exports;